module.exports = __webpack_public_path__ + "static/img/nut_001.282b74fc.png";